// import { Injectable } from '@angular/core';
// import { io, Socket } from 'socket.io-client';
// import { CookieService } from 'ngx-cookie-service';
// @Injectable({
//   providedIn: 'root'
// })
// export class SocketServiceService {
//   socket: any;
//   public token = localStorage.getItem('userAccessToken');

//   constructor(private cookie: CookieService) {
//     this.socket =io('http://20.204.1.103:4050?access_token='+this.token,{transports: ['websocket'],upgrade:false});
//    }

//   setUpSocketConnection() {
//     this.socket =io('http://20.204.1.103:4050?access_token='+this.token,{transports: ['websocket'],upgrade:false});
//   }

// }
import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SocketServiceService {
  socket: any;
  onSuccess: Subject<any> = new Subject<any>();
  onFancySuccess: Subject<any> = new Subject<any>();
  public token = localStorage.getItem('userAccessToken');
  public Base_Url = environment['adminServerUrl'];
  constructor(private cookie: CookieService) {
    let a = this.Base_Url.split('/api/v1/')
    this.socket = io(a[0] + '?access_token=' + this.token, {
      transports: ['websocket'], upgrade: false,
      'reconnection': true,
      autoConnect: true,
      'reconnectionDelay': 1000,
      'reconnectionAttempts': 1000
    });
  }

  setUpSocketConnection() {
    let a = this.Base_Url.split('/api/v1/')
    this.socket = io(a[0] + '?access_token=' + this.token, {
      transports: ['websocket'], upgrade: false,
      'reconnection': true,
       autoConnect: true,
      'reconnectionDelay': 1000,
      'reconnectionAttempts': 1000
    });
  }

  manageRoom(array: any[], joinRoom = true) {
    if (joinRoom) {
      if (array.length > 0) {
        this.socket.connect();
        array.forEach(s => {
          this.joinRoom(s);
        });
      }

      return array;
    } else {
      if (array.length > 0) {
        array.forEach(s => {
          this.leaveRoom(s);
        });
      }

      return [];
    }
  }

  socketOnEvent(eventName:any,callback:any){
    this.socket.on(eventName, (data:any) => callback(data));
  }

  socketEmitEvent(eventName:any,data:any){
    this.socket.emit(eventName, data);
  }


  joinRoom(id: any) {
    this.socket.emit('room', {
      name: 'EID' + id.toString(),
    });
  }

  leaveRoom(id: any, prefix = 'EID') {
    this.socket.emit('leave_room', {
      name: prefix + id.toString(),
    });
  }

  updateData(all: any, runners: any, data: any) {
    if (data === null || !data || Array.isArray(data)) {
      return;
    }

    if (all.length > 0) {
      const m = data;
      const mm = all.find((el: any) => el.marketid.toString() === m.id.toString());
      if (mm) {
        const marketVolume = mm.volume;

        let runnersTemp: any = [];

        const runnerArray = runners.find((el: any) => el.marketId === m.id);
        if (runnerArray) {
          runnersTemp = runnerArray.runners;
        }
        if (m.hasOwnProperty('marketDefinition')) {
          mm.inPlay = m.marketDefinition.inPlay;
          mm.status = m.marketDefinition.status;

          mm.isLive = m.inPlay && m.status === 'OPEN';

          if (m.marketDefinition.hasOwnProperty('runners')) {
            runnersTemp = m.marketDefinition.runners;

            const i = runners.findIndex((el: any) => el.marketId === m.id);

            const dataToApply = { marketId: m.id, runners: runnersTemp };

            if (i > -1) {
              runners[i] = dataToApply;
            } else {
              runners.push(dataToApply);
            }
          }
        }

        const runner = runnersTemp.sort((a: any, b: any) => (a.sortPriority > b.sortPriority ? 1 : -1));

        if (m.hasOwnProperty('rc')) {
          runner.forEach((r: any) => {
            const blData = m.rc.find((el: any) => el.id === r.id);
            if (blData) {
              const dbRunner = mm.runners.find((dr: any) => dr.id.toString() === r.id.toString());

              if (blData.hasOwnProperty('batb')) {
                const back = blData.batb.sort((a: any, b: any) => (a[0] > b[0] ? 1 : -1));

                const bTemp: any = [];
                back.forEach((b: any, i: any) => {
                  dbRunner['back' + i] = { price: b[1], size: (b[2] * marketVolume).toFixed(2) };
                  bTemp.push({ price: b[1], size: (b[2] * marketVolume).toFixed(2) });
                });

                if (dbRunner) {
                  dbRunner.back = bTemp;
                }
              }

              if (blData.hasOwnProperty('batl')) {
                const lay = blData.batl.sort((a: any, b: any) => (a[0] > b[0] ? 1 : -1));

                const lTemp: any = [];

                lay.forEach((b: any, i: any) => {
                  dbRunner['lay' + i] = { price: b[1], size: (b[2] * marketVolume).toFixed(2) };
                  lTemp.push({ price: b[1], size: (b[2] * marketVolume).toFixed(2) });
                });

                if (dbRunner) {
                  dbRunner.lay = lTemp;
                }
              }

              if (r.hasOwnProperty('status')) {
                dbRunner.status = r.status;
              }
            }
          });
        }
      }
    } else {
      console.log('not array');
    }
  }

  updateFancyData(fancies: any, data: any, activeFancy: any = null, side = null, stakeError: any = null) {
    fancies.forEach((f: any) => {
      // const find = data.find(e => e.SelectionId.toString() === f.ind_fancy_selection_id.toString());
      const find = data.find((e: any) => e.SelectionId.toString() === f.ind_fancy_selection_id.toString() && f.is_indian_fancy === 1);
      if (find) {
        f.status = find.GameStatus.trim() === 'ONLINE' ? '' : find.GameStatus.trim();
        f.SessInptYes = find.BackPrice1;
        f.YesValume = find.BackSize1;
        f.SessInptNo = find.LayPrice1;
        f.NoValume = find.LaySize1;

        if (activeFancy) {
          if (f.ind_fancy_selection_id === activeFancy.ind_fancy_selection_id) {
            const valueType = side === 'lay' ? 'SessInptNo' : 'SessInptYes';
            if (f.NoValume !== activeFancy.NoValume || f.YesValume !== activeFancy.YesValume || f.status !== activeFancy.status || f[valueType] !== activeFancy[valueType]) {
              stakeError = 'Run Changed';
            }
          }
        }
      } else {
        if (!f.market_id) {
          f.status = 'Result Awaiting';
        }
      }
    });
  }

  updateLineFancyData(fancies: any, data: any, volume = 1) {
    if (data === null || !data || Array.isArray(data)) {
      return;
    }

    fancies.forEach((f: any) => {
      if (data.id == f.market_id) {
        if (data.hasOwnProperty('marketDefinition')) {
          f.status = data.marketDefinition.status === 'OPEN' ? '' : data.marketDefinition.status;

          if (data.hasOwnProperty('rc')) {
            if (data.rc.length > 0) {
              const runner = data.rc[0];

              if (runner.hasOwnProperty('batb')) {
                const back = runner.batb.sort((a: any, b: any) => (a[0] > b[0] ? 1 : -1));
                // f.SessInptYes = Math.round(back[0][1]);
                // f.YesValume = back[0][2];
                f.SessInptNo = Math.round(back[0][1]);
                f.NoValume = back[0][2] * volume;
              }

              if (runner.hasOwnProperty('batl')) {
                const lay = runner.batl.sort((a: any, b: any) => (a[0] > b[0] ? 1 : -1));
                // f.SessInptNo = Math.round(lay[0][1]);
                // f.NoValume = lay[0][2];
                f.SessInptYes = Math.round(lay[0][1]);
                f.YesValume = lay[0][2] * volume;
              }
            }
          }
        }
      }
    });
  }
}